import styled, { css } from 'styled-components';

export const ListWrapper = styled.div`
	font-family: ${({ theme }) => theme.font};
	width: 100%;
	display: flex;
	flex-direction: column;
`;

// Rows carry no background of their own: the list reads as one block on
// whatever surface it is dropped into.
const BaseRow = styled.div`
	display: flex;
	align-items: center;
	border-radius: 4px;
	border: 1px solid transparent;
`;

export const TitleRow = styled(BaseRow)``;

export const ListItem = styled(BaseRow)<{ $isDragging?: boolean }>`
	border-color: ${({ $isDragging, theme }) => $isDragging ? theme.border.brand : 'transparent'};
`;

export const DragHandle = styled.div<{ $isDragging?: boolean }>`
	color: ${({ $isDragging, theme }) => $isDragging ? theme.text.brand : theme.text.tertiary};
	margin: 0 8px 0 6px;
	cursor: grab;

	&:active {
		cursor: grabbing;
	}
`;

export const IconWrapper = styled.div`
	margin: 0 8px 0 0;
	color: ${({ theme }) => theme.text.tertiary};
`;

export const Content = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	gap: 4px;
	padding: 7px 0;
	overflow: hidden;
	min-width: 0;
`;

const truncateText = css`
	font-size: 14px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
	margin: 0;
`;

export const MainText = styled.p`
	${truncateText}
	color: ${({ theme }) => theme.text.primary};
	font-weight: 400;
`;

export const TitleText = styled.h3`
	${truncateText}
	color: ${({ theme }) => theme.text.primary};
	font-weight: 500;
`;

export const Feature = styled.p`
	font-size: 14px;
	white-space: nowrap;
	margin: 0;
	color: ${({ theme }) => theme.text.tertiary};
	font-weight: 400;
`;
